/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorPaletteGray100 = "#e2e2e2";
export const ColorPaletteGray200 = "#c6c6c6";
export const ColorPaletteGray300 = "#ababab";
export const ColorPaletteGray400 = "#919191";
export const ColorPaletteGray500 = "#757575";
export const ColorPaletteGray600 = "#5e5e5e";
export const ColorPaletteGray700 = "#474747";
export const ColorPaletteGray800 = "#303030";
export const ColorPaletteGray900 = "#1b1b1b";
export const ColorPaletteGray950 = "#111111";
export const ColorPaletteWhite = "#ffffff";
export const ColorPaletteBlack = "#000000";
export const ColorPaletteBrandPrimary100 = "#dafbff";
export const ColorPaletteBrandPrimary200 = "#b4fbff";
export const ColorPaletteBrandPrimary300 = "#20ffff";
export const ColorPaletteBrandPrimary400 = "#06eaff";
export const ColorPaletteBrandPrimary500 = "#05c3dd";
export const ColorPaletteBrandPrimary600 = "#049cb1";
export const ColorPaletteBrandPrimary700 = "#037d8d";
export const ColorPaletteBrandPrimary800 = "#036471";
export const ColorPaletteBrandPrimary900 = "#02505b";
export const ColorPaletteBrandSecondary100 = "#8ae4ff";
export const ColorPaletteBrandSecondary200 = "#00bdf6";
export const ColorPaletteBrandSecondary300 = "#007092";
export const ColorPaletteBrandSecondary400 = "#005670";
export const ColorPaletteBrandSecondary500 = "#003c4e";
export const ColorPaletteBrandSecondary600 = "#002a37";
export const ColorPaletteBrandSecondary700 = "#001d26";
export const ColorPaletteBrandSecondary800 = "#00151b";
export const ColorPaletteBrandAccent400 = "#a1864c";
export const ColorPaletteBrandAccent500 = "#c9a045";
export const ColorPaletteBrandAccent800 = "#41361d";
export const ColorPaletteSpecialtyGreen = "#7ccc6c";
export const ColorPaletteSpecialtyOrange = "#b24e18";
export const ColorPaletteSpecialtyPink = "#e86db2";
export const ColorPaletteSpecialtyPurpleLight = "#6f4384";
export const ColorPaletteSpecialtyPurpleMedium = "#6a2abc";
export const ColorPaletteSpecialtyPurpleMediumDark = "#3f2853";
export const ColorPaletteSpecialtyPurpleDark = "#352036";
export const ColorPaletteSpecialtyPurpleExtraDark = "#1e1820";
export const ColorPaletteSpecialtyRedMedium = "#f52500";
export const ColorPaletteSpecialtyRedDark = "#6d0000";
export const ColorAliasBrandPrimaryExtraLight = "#b4fbff";
export const ColorAliasBrandPrimaryLight = "#20ffff";
export const ColorAliasBrandPrimaryDefault = "#05c3dd";
export const ColorAliasBrandPrimaryMedium = "#049cb1";
export const ColorAliasBrandPrimaryDark = "#037d8d";
export const ColorAliasBrandPrimaryExtraDark = "#036471";
export const ColorAliasBrandSecondaryLight = "#007092";
export const ColorAliasBrandSecondaryDark = "#001d26";
export const ColorAliasBrandSecondaryExtraDark = "#00151b";
export const ColorAliasBrandAccentLight = "#a1864c";
export const ColorAliasBrandAccentDefault = "#c9a045";
export const ColorAliasNeutralWhite = "#ffffff";
export const ColorAliasNeutralBlack = "#000000";
export const ColorAliasNeutralGray100 = "#e2e2e2";
export const ColorAliasNeutralGray200 = "#c6c6c6";
export const ColorAliasNeutralGray300 = "#ababab";
export const ColorAliasNeutralGray400 = "#919191";
export const ColorAliasNeutralGray500 = "#757575";
export const ColorAliasNeutralGray600 = "#5e5e5e";
export const ColorAliasNeutralGray700 = "#474747";
export const ColorAliasNeutralGray800 = "#303030";
export const ColorAliasNeutralGray900 = "#1b1b1b";
export const ColorAliasNeutralGray950 = "#111111";
export const ColorAliasSpecialtyGreen = "#7ccc6c";
export const ColorAliasSpecialtyOrange = "#b24e18";
export const ColorAliasSpecialtyPink = "#e86db2";
export const ColorAliasSpecialtyPurpleLight = "#6f4384";
export const ColorAliasSpecialtyPurpleMedium = "#6a2abc";
export const ColorAliasSpecialtyPurpleDark = "#352036";
export const ColorAliasSpecialtyRedMedium = "#f52500";
export const ColorAliasSpecialtyRedDark = "#6d0000";
export const ColorSemanticLinkDefaultBase = "#05c3dd";
export const ColorSemanticLinkDefaultHover = "#06eaff";
export const ColorSemanticLinkDefaultActive = "#06eaff";
export const ColorSemanticLinkVariantGrayBase = "#757575";
export const ColorSemanticLinkVariantGrayHover = "#919191";
export const ColorSemanticLinkVariantGrayActive = "#919191";
export const ColorSemanticLinkVariantWhiteBase = "#ffffff";
export const ColorSemanticLinkVariantWhiteHover = "#e2e2e2";
export const ColorSemanticLinkVariantWhiteActive = "#e2e2e2";
export const ColorSemanticLinkVariantBrandPrimaryBase = "#05c3dd";
export const ColorSemanticLinkVariantBrandPrimaryHover = "#06eaff";
export const ColorSemanticLinkVariantBrandPrimaryActive = "#06eaff";
export const FontFamilyGraphie = "Graphie, sans-serif";
export const FontLetterSpacingTight = "0";
export const FontLetterSpacingNormal = ".5px";
export const FontLetterSpacingLoose = "2px";
export const FontLineHeightTight = "1";
export const FontLineHeightNormal = "1.2";
export const FontLineHeightRelaxed = "1.5";
export const FontLineHeightLoose = "1.8";
export const FontLineHeightBody = "1.5";
export const FontSize100 = "10px";
export const FontSize200 = "11px";
export const FontSize300 = "12px";
export const FontSize400 = "14px";
export const FontSize500 = "16px";
export const FontSize600 = "18px";
export const FontSize700 = "20px";
export const FontSize800 = "22px";
export const FontSize900 = "24px";
export const FontSize1000 = "28px";
export const FontSize1100 = "32px";
export const FontSize1200 = "48px";
export const FontSize1300 = "56px";
export const FontSize1400 = "64px";
export const FontSizeBodyXxxs = "10px";
export const FontSizeBodyXxs = "11px";
export const FontSizeBodyXs = "12px";
export const FontSizeBodySm = "14px";
export const FontSizeBodyMd = "16px";
export const FontSizeBodyMdPlus = "18px";
export const FontSizeBodyLg = "20px";
export const FontSizeBodyLgPlus = "22px";
export const FontSizeHeadingH1Mobile = "32px";
export const FontSizeHeadingH1Desktop = "48px";
export const FontSizeHeadingH2Mobile = "24px";
export const FontSizeHeadingH2Desktop = "28px";
export const FontSizeHeadingH3Mobile = "20px";
export const FontSizeHeadingH3Desktop = "22px";
export const FontSizeHeadingH4Mobile = "18px";
export const FontSizeHeadingH4Desktop = "20px";
export const FontSizeHeadingH5Mobile = "16px";
export const FontSizeHeadingH5Desktop = "18px";
export const FontSizeHeadingSpecialtyDisplayLgMobile = "48px";
export const FontSizeHeadingSpecialtyDisplayLgDesktop = "64px";
export const FontSizeHeadingSpecialtyDisplayMobile = "48px";
export const FontSizeHeadingSpecialtyDisplayDesktop = "56px";
export const FontWeightUltraLight = 200;
export const FontWeightLight = 350;
export const FontWeightSemiBold = 400;
export const FontWeightBold = 500;
export const FontWeightExtraBold = 600;
export const SizeBreakpointXs = 390;
export const SizeBreakpointSmMinus = 600;
export const SizeBreakpointSm = 768;
export const SizeBreakpointMd = 1128;
export const SizeBreakpointMdPlus = 1280;
export const SizeBreakpointLg = 1440;
export const SizeBreakpointXl = 1920;
export const SizeBreakpointXxl = 2560;
export const ComponentNavigationHeaderHeight = "60px";
export const ComponentCarouselV2PeekOffset = "30px";
export const ComponentCarouselV2ArrowNavWidth = "72px";
export const ComponentModalDialogPaddingX = "20px";
export const ComponentModalDialogPaddingY = "20px";
export const SpacingScale1 = "8px";
export const SpacingScale2 = "16px";
export const SpacingScale3 = "24px";
export const SpacingScale4 = "32px";
export const SpacingScale5 = "40px";
export const SpacingScale6 = "48px";
export const SpacingScale7 = "56px";
export const SpacingScale8 = "64px";
export const SpacingScale9 = "72px";
export const SpacingScale10 = "80px";
export const SpacingScale11 = "88px";
export const SpacingScale12 = "96px";
export const SpacingModuleSmTopDesktop = "40px";
export const SpacingModuleSmTopMobile = "18px";
export const SpacingModuleSmBottomDesktop = "40px";
export const SpacingModuleSmBottomMobile = "18px";
export const SpacingModuleMdTopDesktop = "72px";
export const SpacingModuleMdTopMobile = "40px";
export const SpacingModuleMdBottomDesktop = "72px";
export const SpacingModuleMdBottomMobile = "40px";
export const SpacingModuleLgTopDesktop = "100px";
export const SpacingModuleLgTopMobile = "70px";
export const SpacingModuleLgBottomDesktop = "100px";
export const SpacingModuleLgBottomMobile = "70px";
export const SpacingLegacyScale1 = "20px";
export const SpacingLegacyScale2 = "35px";
export const SpacingLegacyScale3 = "55px";
export const SpacingLegacyScale4 = "70px";
export const SpacingLegacyModule = "48px";
export const TypographyBodyFontFamily = "Graphie, sans-serif";
export const TypographyBodyFontWeight = 350;
export const TypographyBodyLineHeight = "1.5";
export const TypographyBodyLetterSpacing = ".5px";
export const TypographyHeadingFontFamily = "Graphie, sans-serif";
export const TypographyHeadingFontWeight = 500;
export const TypographyHeadingLineHeightDesktop = "1.5";
export const TypographyHeadingLineHeightMobile = "1.2";
export const TypographyHeadingH1FontFamily = "Graphie, sans-serif";
export const TypographyHeadingH1FontWeight = 500;
export const TypographyHeadingH1LineHeightDesktop = "1.5";
export const TypographyHeadingH1LineHeightMobile = "1.2";
export const TypographyHeadingH1FontSizeDesktop = "48px";
export const TypographyHeadingH1FontSizeMobile = "32px";
export const TypographyHeadingH1MarginTopDesktop = "0";
export const TypographyHeadingH1MarginTopMobile = "32px";
export const TypographyHeadingH1MarginBottomDesktop = "64px";
export const TypographyHeadingH1MarginBottomMobile = "64px";
export const TypographyHeadingH2FontFamily = "Graphie, sans-serif";
export const TypographyHeadingH2FontWeight = 500;
export const TypographyHeadingH2LineHeightDesktop = "1.5";
export const TypographyHeadingH2LineHeightMobile = "1.2";
export const TypographyHeadingH2FontSizeDesktop = "28px";
export const TypographyHeadingH2FontSizeMobile = "24px";
export const TypographyHeadingH2MarginTopDesktop = "32px";
export const TypographyHeadingH2MarginTopMobile = "32px";
export const TypographyHeadingH2MarginBottomDesktop = "32px";
export const TypographyHeadingH2MarginBottomMobile = "24px";
export const TypographyHeadingH3FontFamily = "Graphie, sans-serif";
export const TypographyHeadingH3FontWeight = 500;
export const TypographyHeadingH3LineHeightDesktop = "1.5";
export const TypographyHeadingH3LineHeightMobile = "1.2";
export const TypographyHeadingH3FontSizeDesktop = "22px";
export const TypographyHeadingH3FontSizeMobile = "20px";
export const TypographyHeadingH3MarginTopDesktop = "0";
export const TypographyHeadingH3MarginTopMobile = "0";
export const TypographyHeadingH3MarginBottomDesktop = "16px";
export const TypographyHeadingH3MarginBottomMobile = "16px";
export const TypographyHeadingH4FontFamily = "Graphie, sans-serif";
export const TypographyHeadingH4FontWeight = 500;
export const TypographyHeadingH4LineHeightDesktop = "1.5";
export const TypographyHeadingH4LineHeightMobile = "1.2";
export const TypographyHeadingH4FontSizeDesktop = "20px";
export const TypographyHeadingH4FontSizeMobile = "18px";
export const TypographyHeadingH4MarginTopDesktop = "0";
export const TypographyHeadingH4MarginTopMobile = "0";
export const TypographyHeadingH4MarginBottomDesktop = "0";
export const TypographyHeadingH4MarginBottomMobile = "0";
export const TypographyHeadingH5FontFamily = "Graphie, sans-serif";
export const TypographyHeadingH5FontWeight = 500;
export const TypographyHeadingH5LineHeightDesktop = "1.5";
export const TypographyHeadingH5LineHeightMobile = "1.2";
export const TypographyHeadingH5FontSizeDesktop = "18px";
export const TypographyHeadingH5FontSizeMobile = "16px";
export const TypographyHeadingH5MarginTopDesktop = "0";
export const TypographyHeadingH5MarginTopMobile = "0";
export const TypographyHeadingH5MarginBottomDesktop = "0";
export const TypographyHeadingH5MarginBottomMobile = "0";
export const TypographyHeadingDisplayLgFontFamily = "Graphie, sans-serif";
export const TypographyHeadingDisplayLgFontWeight = 500;
export const TypographyHeadingDisplayLgLineHeightDesktop = "1.5";
export const TypographyHeadingDisplayLgLineHeightMobile = "1.2";
export const TypographyHeadingDisplayLgFontSizeDesktop = "64px";
export const TypographyHeadingDisplayLgFontSizeMobile = "48px";
export const TypographyHeadingDisplayLgMarginTopDesktop = "0";
export const TypographyHeadingDisplayLgMarginTopMobile = "0";
export const TypographyHeadingDisplayLgMarginBottomDesktop = "64px";
export const TypographyHeadingDisplayLgMarginBottomMobile = "64px";
export const TypographyHeadingDisplayFontFamily = "Graphie, sans-serif";
export const TypographyHeadingDisplayFontWeight = 500;
export const TypographyHeadingDisplayLineHeightDesktop = "1.5";
export const TypographyHeadingDisplayLineHeightMobile = "1.2";
export const TypographyHeadingDisplayFontSizeDesktop = "56px";
export const TypographyHeadingDisplayFontSizeMobile = "48px";
export const TypographyHeadingDisplayMarginTopDesktop = "0";
export const TypographyHeadingDisplayMarginTopMobile = "0";
export const TypographyHeadingDisplayMarginBottomDesktop = "64px";
export const TypographyHeadingDisplayMarginBottomMobile = "64px";
export const ComponentsButtonSizeSmFontSizeMobile = "12px";
export const ComponentsButtonSizeSmFontSizeDesktop = "12px";
export const ComponentsButtonSizeSmFontWeight = 350;
export const ComponentsButtonSizeSmPaddingX = "8px";
export const ComponentsButtonSizeSmPaddingY = "16px";
export const ComponentsButtonSizeSmTextHeight = "16px";
export const ComponentsButtonSizeMdFontSizeMobile = "12px";
export const ComponentsButtonSizeMdFontSizeDesktop = "14px";
export const ComponentsButtonSizeMdFontWeight = 350;
export const ComponentsButtonSizeMdPaddingX = "8px";
export const ComponentsButtonSizeMdPaddingY = "16px";
export const ComponentsButtonSizeMdTextHeight = "16px";
export const ComponentsButtonSizeLgFontSizeMobile = "18px";
export const ComponentsButtonSizeLgFontSizeDesktop = "18px";
export const ComponentsButtonSizeLgFontWeight = 350;
export const ComponentsButtonSizeLgPaddingX = "8px";
export const ComponentsButtonSizeLgPaddingY = "16px";
export const ComponentsButtonSizeLgTextHeight = "22px";
export const ComponentsButtonSizeXlFontSizeMobile = "18px";
export const ComponentsButtonSizeXlFontSizeDesktop = "18px";
export const ComponentsButtonSizeXlFontWeight = 400;
export const ComponentsButtonSizeXlPaddingX = "16px";
export const ComponentsButtonSizeXlPaddingY = "24px";
export const ComponentsButtonSizeXlTextHeight = "22px";
export const ComponentsButtonThemePrimaryBackgroundDefaultStart = "#20ffff";
export const ComponentsButtonThemePrimaryBackgroundDefaultEnd = "#05c3dd";
export const ComponentsButtonThemePrimaryBackgroundHoverStart = "#05c3dd";
export const ComponentsButtonThemePrimaryBackgroundHoverEnd = "#20ffff";
export const ComponentsButtonThemePrimaryColorDefault = "#000000";
export const ComponentsButtonThemePrimaryColorHover = "#000000";
export const ComponentsButtonThemePrimaryBorderWidth = "0";
export const ComponentsButtonThemePrimaryBorderColor = "transparent";
export const ComponentsButtonThemePrimaryAccentBackgroundDefaultStart =
  "#a1864c";
export const ComponentsButtonThemePrimaryAccentBackgroundDefaultEnd = "#c9a045";
export const ComponentsButtonThemePrimaryAccentBackgroundHoverStart = "#c9a045";
export const ComponentsButtonThemePrimaryAccentBackgroundHoverEnd = "#a1864c";
export const ComponentsButtonThemePrimaryAccentColorDefault = "#000000";
export const ComponentsButtonThemePrimaryAccentColorHover = "#000000";
export const ComponentsButtonThemePrimaryAccentBorderWidth = "0";
export const ComponentsButtonThemePrimaryAccentBorderColor = "transparent";
export const ComponentsButtonThemeSecondaryBackgroundDefaultStart = "#c6c6c6";
export const ComponentsButtonThemeSecondaryBackgroundDefaultEnd = "#ffffff";
export const ComponentsButtonThemeSecondaryBackgroundHoverStart = "#ffffff";
export const ComponentsButtonThemeSecondaryBackgroundHoverEnd = "#c6c6c6";
export const ComponentsButtonThemeSecondaryColorDefault = "#000000";
export const ComponentsButtonThemeSecondaryColorHover = "#000000";
export const ComponentsButtonThemeSecondaryBorderWidth = "0";
export const ComponentsButtonThemeSecondaryBorderColor = "transparent";
export const ComponentsButtonThemeTierraryBackgroundDefaultStart =
  "transparent";
export const ComponentsButtonThemeTierraryBackgroundDefaultEnd = "transparent";
export const ComponentsButtonThemeTierraryBackgroundHoverStart = "#ffffff";
export const ComponentsButtonThemeTierraryBackgroundHoverEnd = "#c6c6c6";
export const ComponentsButtonThemeTierraryColorDefault = "#ffffff";
export const ComponentsButtonThemeTierraryColorHover = "#000000";
export const ComponentsButtonThemeTierraryBorderWidth = "1px";
export const ComponentsButtonThemeTierraryBorderColor = "#ffffff";
export const ComponentsButtonThemeDisabledBackgroundDefaultStart = "#5e5e5e";
export const ComponentsButtonThemeDisabledBackgroundDefaultEnd = "#5e5e5e";
export const ComponentsButtonThemeDisabledBackgroundHoverStart = "#5e5e5e";
export const ComponentsButtonThemeDisabledBackgroundHoverEnd = "#5e5e5e";
export const ComponentsButtonThemeDisabledColorDefault = "#c6c6c6";
export const ComponentsButtonThemeDisabledColorHover = "#c6c6c6";
export const ComponentsButtonThemeDisabledBorderWidth = "0";
export const ComponentsButtonThemeDisabledBorderColor = "transparent";
